import Ajv from 'ajv';
import * as GarageAccountScheme from './scheme.json';

const ajv = new Ajv();
export const GarageAccountValidator = ajv.compile(GarageAccountScheme);
